/**
 * Umi Max 运行时配置入口
 *
 * 职责：
 * - 初始化 React 兼容性配置
 * - 导出全局初始化函数
 * - 导出 Layout 布局配置
 * - 导出路由变化监听
 * - 导出全局请求配置
 *
 * @doc https://umijs.org/docs/api/runtime-config
 */

import type { RequestConfig } from '@umijs/max';
import { getInitialState } from './core/initialState';
import { setupReact19Compatibility } from './core/reactCompat';
import { onRouteChange } from './core/routeChange';
import { errorConfig } from './requestErrorConfig';
import { getGlobalContentSize, sizeConfig } from './stores/contentSize';

// 引入 Font Awesome CSS
import 'font-awesome/css/font-awesome.min.css';

// ==================== 初始化配置 ====================

// React 19 兼容性配置（立即执行）
setupReact19Compatibility();

// 初始化内容大小 CSS 变量
const initContentSize = () => {
  const size = getGlobalContentSize();
  const config = sizeConfig[size];
  const root = document.documentElement;
  Object.entries(config).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
};

// 在 DOM 加载完成后初始化
if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContentSize);
  } else {
    initContentSize();
  }
}

// ==================== 导出运行时配置 ====================

// 全局初始状态
export { getInitialState };

// 路由变化监听
export { onRouteChange };

// 全局请求配置
const isDev = process.env.NODE_ENV === 'development';
const API_HOST = process.env.REACT_APP_API_HOST || '';

export const request: RequestConfig = {
  baseURL: isDev ? API_HOST : 'https://dongdong.tanwer.cn',
  ...errorConfig,
};
